export default {"src":"/_next/static/media/ABT.266d1247.svg","height":18,"width":18};